import CourseNavigationLayout from "@/screens/CourseNavigationLayout.jsx";

export default function TriaLessonPage() {
  const navItems = [
    {
      path: "/course/trial/lessons",
      value: "course",
      label: "Курсы",
      onProgress: false,
    },
    {
      path: "/course/trial/products-list",
      value: "productList",
      label: "Список Товаров",
      onProgress: false,
    },
    {
      path: "/course/trial/chat",
      value: "chats",
      label: "Чат с наставником",
      onProgress: false,
    },
    {
      path: "/course/trial/ai",
      value: "ai",
      label: "ИИ чат",
      onProgress: false,
    },
    {
      path: "/course/trial/invest",
      value: "invest",
      label: "Инвестор",
      onProgress: false,
    },

    {
      path: "/course/trial/telegram",
      value: "telegram",
      label: "Телеграм канал",
      onProgress: false,
      externalLink: `https://t.me/orlandiya22`,
    },
  ];

  return <CourseNavigationLayout navItems={navItems} />;
}
